import { slicedToArray as _slicedToArray, objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { memo, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useJsApiLoader, GoogleMap, Marker, InfoWindow } from '@react-google-maps/api';
import { tLoc, t } from '../../i18n/translate.js';
import img from '../../testutils/images/map-test.png.js';
import Button from '../../components/Button/Button.js';
import '../../components/AppLogo/AppLogo.js';
import '../../components/Avatar/Avatar.js';
import '../../components/Input/Input.js';
import '../../components/Input/PasswordInput.js';
import Icon from '../../components/Icon/Icon.js';
import '../../components/Image/Image.js';
import LoadingSpinner from '../../components/LoadingSpinner/LoadingSpinner.js';
import '../../components/Note/Note.js';
import '../../components/RadioButton/RadioButton.js';
import '../../components/RoundButton/RoundButton.js';
import '../../components/RoundButton/RoundButtonElement/RoundButtonElement.js';
import '../../components/Expandable/Expandable.js';
import '../../components/PopOver/PopOver.js';
import '../../components/Wizard/Wizard.js';
import '../../components/Wizard/WizardStepContent/WizardStepContent.js';
import '../../components/Wizard/NavigationBar/NavigationBar.js';
import '../../components/ToggleButton/ToggleButton.js';
import '../../components/ToggleButton/ToggleButtonElement/ToggleButtonElement.js';
import '../../components/Wizard/ProgressBar/ProgressBar.js';
import '../../components/Checkbox/Checkbox.js';
import '../../components/SelectionField/SelectionField.js';
import '../../components/Card/Card.js';
import '../../components/Badge/Badge.js';
import '../../components/SettingsItem/SettingsItem.js';
import '../../components/SortableList/SortableList.js';
import '../../components/Contacts/ContactItem.js';
import '../../components/TopElement/TopElement.js';
import '../../components/SidePanelInfoBox/SidePanelInfoBox.js';
import 'classnames';
import '../../components/Flag/Flag.js';
import '../../i18n/i18n.js';
import '../../services/apiEndpoint/apiEndpoint.js';
import { GOOGLE_MAPS_API_KEY } from '../../services/appConstants/appConstants.js';
import '../../node_modules/tslib/tslib.es6.js';
import 'react-ga4';
import '../../services/utilities/countries.js';
import '@sentry/react';
import '@apollo/client';
import '@apollo/client/link/batch-http';
import '@apollo/client/link/error';
import 'uuid';
import '../../services/graphql/default-client/DefaultClient.js';
import 'axios';
import 'date-fns/isAfter';
import 'date-fns/addMinutes';
import '../../services/logout/rest-default-client/restDefaultClient.js';
import '../../services/poller/PollManager.js';
import 'react-dom';
import 'react-redux';
import '../../services/ipcWeb/IpcContext.js';
import 'js-cookie';
import 'react-i18next';
import '../../services/translation/translationUtils.module.scss.js';
import '../../services/utilities/languageUtil.js';
import '../../services/useContactUs/ContactUs.gql.js';
import '../../services/storageHandler/StorageHandler.js';
import '../../services/abortablePromise/AbortablePromise.js';
import '../../services/abortablePoller/AbortablePoller.js';
import '../../services/abortablePoller/ResumablePoller.js';
import '../../services/ipcWeb/ipcService.js';
import '../../components/DropDownBox/DropDownBox.module.scss.js';
import '../../components/PhoneSelectButton/PhoneSelectButton.module.scss.js';
import '../../components/InternationalPhonePicker/InternationalPhonePicker.module.scss.js';
import '../../components/Carousel/ImageCarousel.module.scss.js';
import styles from './LocationMap.module.scss.js';

var LocationMapComponent = function LocationMapComponent(_ref) {
  var testMode = _ref.testMode,
    installationAddress = _ref.installationAddress,
    setGps = _ref.setGps,
    interactive = _ref.interactive,
    sendMail = _ref.sendMail,
    mailSent = _ref.mailSent,
    overrideLabels = _ref.overrideLabels;
  var mapSize = {
    width: '37.5rem',
    height: '37.5rem'
  };
  var longitude = installationAddress.longitude,
    latitude = installationAddress.latitude,
    street = installationAddress.street,
    city = installationAddress.city,
    streetNumber = installationAddress.streetNumber;
  var defaultCenter = {
    // delaer based default in case no gps is supplied? as now is mid of france, but should never happen to be without gps
    lat: latitude ? parseFloat(latitude) : 48.8434305,
    lng: longitude ? parseFloat(longitude) : 2.3205713
  };
  var _useState = useState(defaultCenter),
    _useState2 = _slicedToArray(_useState, 2),
    center = _useState2[0],
    setCenter = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    mapref = _useState4[0],
    setMapRef = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    selectedMarker = _useState6[0],
    setSelectedMarker = _useState6[1];
  var _useState7 = useState(defaultCenter.lat),
    _useState8 = _slicedToArray(_useState7, 2),
    newLat = _useState8[0],
    setNewLat = _useState8[1];
  var _useState9 = useState(defaultCenter.lng),
    _useState10 = _slicedToArray(_useState9, 2),
    newLng = _useState10[0],
    setNewLng = _useState10[1];
  var _useJsApiLoader = useJsApiLoader({
      id: 'google-map-script',
      googleMapsApiKey: GOOGLE_MAPS_API_KEY
    }),
    isLoaded = _useJsApiLoader.isLoaded;
  var compositeAddress = "".concat(street, " ").concat(streetNumber || '', ", ").concat(city);
  var defaultLabels = {
    emailButton: t('MPLIB_GUARD_ACCESS_WRONG_COORDS'),
    emailSent: tLoc('MPLIB_WIZARD_EMAIL_SENT_TITLE')
  };
  var mergedLabels = _objectSpread2(_objectSpread2({}, defaultLabels), overrideLabels);
  var initMaps = function initMaps() {
    if (longitude && latitude) {
      setCenter({
        lat: parseFloat(latitude),
        lng: parseFloat(longitude)
      });
      setGps({
        lat: parseFloat(latitude),
        lng: parseFloat(longitude)
      });
    } else {
      var gmGeocoder = new window.google.maps.Geocoder();
      gmGeocoder.geocode({
        address: compositeAddress
      }, function (results, status) {
        if (status === 'OK') {
          var coord = {
            lat: results[0].geometry.location.lat(),
            lng: results[0].geometry.location.lng()
          };
          setCenter(coord);
          setGps(coord);
        } else {
          setGps(defaultCenter);
        }
      });
    }
  };
  useEffect(function () {
    if (isLoaded && !testMode) {
      initMaps();
    }
    if (testMode) {
      setGps({
        lat: parseFloat(latitude),
        lng: parseFloat(longitude)
      });
    }
  }, [isLoaded, testMode]);
  var handleMarkerClick = function handleMarkerClick(marker) {
    setSelectedMarker(marker);
  };
  var handleCenterChanged = function handleCenterChanged() {
    if (mapref) {
      var lat = mapref.getCenter().lat();
      var lng = mapref.getCenter().lng();
      setCenter({
        lat: lat,
        lng: lng
      });
      setNewLat(lat);
      setNewLng(lng);
      setGps({
        lat: lat,
        lng: lng
      });
    }
  };
  var handleOnLoad = function handleOnLoad(map) {
    setMapRef(map);
  };
  return isLoaded ? /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement("article", {
    className: styles.address
  }, /*#__PURE__*/React.createElement("label", null, t('MPLIB_GUARD_ACCESS_GPS_COORDS')), /*#__PURE__*/React.createElement("p", {
    className: "secondary"
  }, compositeAddress, " "), /*#__PURE__*/React.createElement("p", {
    className: "secondary"
  }, t('MPLIB_ETC_LATITUDE'), ": ", newLat || latitude || t('MPLIB_NOT_AVAILABLE')), /*#__PURE__*/React.createElement("p", {
    className: "secondary"
  }, t('MPLIB_ETC_LONGITUDE'), ": ", newLng || longitude || t('MPLIB_NOT_AVAILABLE'))), /*#__PURE__*/React.createElement("div", {
    className: styles.center
  }, /*#__PURE__*/React.createElement("div", null, testMode ? /*#__PURE__*/React.createElement("img", {
    width: "375",
    height: "375",
    src: img,
    alt: "map-test"
  }) : /*#__PURE__*/React.createElement(GoogleMap, {
    onLoad: handleOnLoad,
    mapContainerStyle: mapSize,
    onDragEnd: interactive ? handleCenterChanged : null,
    center: center,
    zoom: 17
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Marker, {
    position: center,
    onClick: function onClick() {
      return handleMarkerClick(center);
    }
  }), selectedMarker && /*#__PURE__*/React.createElement(InfoWindow, {
    position: selectedMarker,
    onCloseClick: function onCloseClick() {
      return setSelectedMarker(null);
    },
    options: {
      pixelOffset: new window.google.maps.Size(0, -30)
    }
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h1", null, "".concat(street, " ").concat(streetNumber || '')), " ", /*#__PURE__*/React.createElement("h1", null, city))))), !interactive && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    text: mergedLabels.emailButton,
    onClick: sendMail,
    disabled: mailSent,
    secondary: true,
    className: styles.button,
    dataTestId: "wrong-coords"
  }), mailSent && /*#__PURE__*/React.createElement("p", {
    className: styles.sentmail
  }, mergedLabels.emailSent, /*#__PURE__*/React.createElement(Icon, {
    icon: "icon-checkmark",
    size: "medium",
    color: "green"
  })))), interactive && /*#__PURE__*/React.createElement("div", {
    className: styles.square,
    id: "cross"
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.horizontal
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.vertical
  })))) : /*#__PURE__*/React.createElement(LoadingSpinner, {
    isLoading: true,
    centered: true,
    relative: true,
    size: "small"
  });
};
LocationMapComponent.propTypes = {
  interactive: PropTypes.bool,
  testMode: PropTypes.bool,
  installationAddress: PropTypes.shape({
    longitude: PropTypes.string,
    latitude: PropTypes.string,
    street: PropTypes.string.isRequired,
    city: PropTypes.string.isRequired,
    streetNumber: PropTypes.string
  }).isRequired,
  setGps: PropTypes.func,
  sendMail: PropTypes.func,
  mailSent: PropTypes.bool,
  overrideLabels: PropTypes.shape({})
};
LocationMapComponent.defaultProps = {
  testMode: false,
  interactive: true,
  setGps: function setGps() {
    return null;
  },
  sendMail: function sendMail() {
    return null;
  },
  mailSent: false,
  overrideLabels: null
};
var LocationMap = /*#__PURE__*/memo(LocationMapComponent);

export { LocationMap };
